<div class="more_product_modal">
    <div class="modal-header">
        <h4>{{ currentInstance }}</h4>
        <a class="close-icon" href="javascript:void(0)" (click)="closeFunction()"><i class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-body output-lable">
        <div class="row">
            <div class="col-md-12">
                <div class="filter_section search-wrapper mb-4">
                    <mat-form-field>
                        <input matInput type="text" placeholder="Search" (keyup)="searchResult($event)" [(ngModel)]="searchInput" />
                        <button mat-button matPrefix mat-icon-button class="search_btn">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="section">
                    <div class="instance_data" *ngIf="projectsList?.length; else noData">
                        <div *ngFor="let p of projectsList; let i = index">
                            <div class="plant-section">
                                <div class="child_section">
                                    <div class="d-flex justify-content-between align-items-center" (click)="selectProject(p)">
                                        <a>
                                            {{ type == 'IceDatabase' || type == 'instance-conf-sidebar' ? p.name : p.namePrimary }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer custom-pagination-wrap">
        <mat-paginator [length]="totalProjects" [pageSize]="pageSize" (page)="onPageChange($event)" [pageIndex]="currentPageIndex"></mat-paginator>
    </div>
</div>
<ng-template #noData>
    <div class="plant-section">
        <div class="child_section">
            <div class="d-flex justify-content-between align-items-center">
                <p class="no-data-mesaage">No {{ itemName }} Available.</p>
            </div>
        </div>
    </div>
</ng-template>
